import React from 'react';
import { Modal, ModalHeader, ModalBody, Button, Table } from 'reactstrap';

const ModalDetalleGastoRendicion = ({ isOpen, onClose, rendicion }) => {
    if (!rendicion) return null;

    const detalles = rendicion.detalles || [];

    const titulos = {
        1: 'GASTOS DE MOVILIDAD',
        2: 'GASTOS DE ALIMENTACIÓN',
        3: 'GASTOS DE HOSPEDAJE',
        4: 'GASTOS SIN SUSTENTO'
    };

    const formatoSoles = (monto) => {
        return new Intl.NumberFormat('es-PE', {
            style: 'currency',
            currency: 'PEN',
        }).format(monto || 0);
    };

    const getTipoComprobante = (tc) => {
        if (tc === "1" || tc === 1) return 'BOLETA';
        if (tc === "2" || tc === 2) return 'FACTURA';
        return tc;
    };

    const renderTabla = (tipo) => {
        const rows = detalles.filter(d => Number(d.tipo_gasto) === tipo);
        if (rows.length === 0) return null;

        const hasComprobantes = tipo !== 4;

        return (
            <div key={tipo} className="mb-4">
                <h6 className="font-bold text-primary text-sm mb-2">{titulos[tipo]}</h6>
                <div className="table-container shadow-sm overflow-x-auto m-0">
                    <Table bordered size="sm" className="text-xs m-0">
                        <thead className="bg-[#14233a] text-white text-center align-middle">
                            <tr>
                                <th>Fecha</th>
                                <th>Lugar</th>
                                <th>Detalle</th>
                                {hasComprobantes && <th>Proveedor</th>}
                                {hasComprobantes && <th>Comprobante</th>}
                                {hasComprobantes && <th>Serie</th>}
                                {hasComprobantes && <th>Número</th>}
                                <th>Monto</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((det, idx) => (
                                <tr key={idx} className="align-middle text-center">
                                    <td>{det.fecha_gasto}</td>
                                    <td>{det.lugar_gasto}</td>
                                    <td>{det.detalle_gasto}</td>
                                    {hasComprobantes && (
                                        <>
                                            <td>{det.proveedor}</td>
                                            <td>{getTipoComprobante(det.tipo_comprobante)}</td>
                                            <td>{det.serie_comprobante}</td>
                                            <td>{det.numero_comprobante}</td>
                                        </>
                                    )}
                                    <td className="text-right">{formatoSoles(det.monto_pago)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </div>
        );
    };

    const tiposExistentes = [1, 2, 3, 4].filter(tipo => detalles.some(d => Number(d.tipo_gasto) === tipo));

    return (
        <>
            <style>
                {`
                    .modal-dialog.custom-modal-xl {
                        max-width: 98% !important;
                        width: 98% !important;
                        margin: 1rem auto;
                    }
                    .modal-content {
                        min-height: 50vh;
                    }
                `}
            </style>
            <Modal isOpen={isOpen} toggle={onClose} className="custom-modal-xl" size="xl">
                <ModalHeader className="modal-header">
                    <div className="titulo">
                        <h1>DETALLES DE RENDICIÓN</h1>
                        <Button className="close-btn" onClick={onClose}>X</Button>
                    </div>
                </ModalHeader>
                <ModalBody className="modal-body" style={{ color: '#333', fontSize: '14px', padding: 0 }}>
                    <div style={{ padding: '1.5rem 2rem', overflowY: 'auto', maxHeight: '70vh' }}>
                        {tiposExistentes.length > 0 ? (
                            tiposExistentes.map(tipo => renderTabla(tipo))
                        ) : (
                            <div className="text-center text-muted py-4">
                                No hay gastos registrados en esta rendición.
                            </div>
                        )}

                        <div className="flex justify-end mt-4">
                            <div className="table-container shadow-sm overflow-x-auto" style={{ width: '100%', maxWidth: '400px' }}>
                                <Table bordered size="sm" className="text-xs m-0">
                                    <thead className="bg-[#14233a] text-white text-center">
                                        <tr>
                                            <th colSpan="2">Resumen final</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="font-bold">Monto recibido</td>
                                            <td className="text-right font-bold text-primary">{formatoSoles(Number(rendicion.monto_recibido) || 0)}</td>
                                        </tr>
                                        <tr>
                                            <td className="font-bold">Monto rendido</td>
                                            <td className="text-right font-bold text-success">{formatoSoles(Number(rendicion.monto_rendido) || 0)}</td>
                                        </tr>
                                        <tr>
                                            <td className="font-bold">Devolución</td>
                                            <td className="text-right font-bold text-danger">{formatoSoles(Number(rendicion.monto_devolucion) || 0)}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
};

export default ModalDetalleGastoRendicion;
